export const newTypesOfDisabilities = [
  { value: 'general_disease', label: 'General Disease' },
  { value: 'traffic_accident', label: 'Traffic Accident' },
  { value: 'maternal_leave', label: 'Maternal Leave' },
  { value: 'parental_leave', label: 'Parental Leave' },
  { value: 'work_accident', label: 'Work Accident' },
];

export const TypesOfDisabilitiesAdmin = [
  { value: '1', label: 'General Disease', value_form :'general_disease' },
  { value: '2', label: 'Traffic Accident', value_form :'traffic_accident' },
  { value: '3', label: 'Maternal Leave', value_form :'maternal_leave' },
  { value: '4', label: 'Parental Leave', value_form :'parental_leave' },
  { value: '5', label: 'Work Accident', value_form :'work_accident' },
];

export const StatusOptions = [
  { value: '1', label: 'In process' },
  { value: '2', label: 'Authorized' },
  { value: '3', label: 'Rejected' },
  { value: '4', label: 'Filed EPS' },
  { value: '5', label: 'Paid by EPS' },
  { value: '6', label: 'Denied by the EPS' },
  { value: '7', label: 'In process again' },
  { value: '8', label: 'False Disability' },
  { value: '9', label: 'False Documentation' },
  { value: '10', label: 'Document does not correspond' },
  { value: '11', label: 'Retired staff' },
  { value: '12', label: 'Paid' },
];

export const RejectedOptions = [
 { value: '1', label: 'Incomplete documentation'},
 { value: '2', label: 'Data error'},
 { value: '3', label: 'Blank file, image cut off, no image or illegible'},
 { value: '4', label: 'Blank file, image cut off, no image or illegible (No disability format)'},
 { value: '5', label: 'The document is not a disability certificate, you must process your absence with your immediate supervisor'},
 { value: '6', label: 'The disability form does not meet the minimum requirements (NIT and company name of the service provider, Diagnosis, Data and Signature of the doctor, Type of disability, Start and end date), Epicrisis or complete medical management required'},
 { value: '7', label: 'The disability form does not meet the minimum requirements (NIT and company name of the service provider, Diagnosis, Data and Signature of the doctor, Type of disability, Start and end date) (Patient data)'},
 { value: '8', label: 'Incorrectly issued disability by entity (Greater than 30 days)'},
 { value: '9', label: 'Incorrectly issued disability by entity (Number of days does not correspond with dates)'},
 { value: '10', label: 'Complete copy of FURIPS required'},
 { value: '11', label: 'Complete copy of FURIPS required, Complete epicrisis or medical management required'},
 { value: '12', label: 'Complete copy of SOAT required, Complete copy of FURIPS required'},
 { value: '13', label: 'Complete copy of SOAT required, Complete copy of FURIPS required, Complete epicrisis or medical management required'},
 { value: '14', label: 'Complete epicrisis or medical management required'},
 { value: '15', label: 'Complete epicrisis or medical management required, Epicrisis with weeks of gestation required'},
 { value: '16', label: 'The disability form does not meet the minimum requirements (NIT and company name of the service provider, Diagnosis, Data and Signature of the doctor, Type of disability, Start and end date) (Diagnosis)'},
 { value: '18', label: 'The disability form does not meet the minimum requirements (NIT and company name of the service provider, Diagnosis, Data and Signature of the doctor, Type of disability, Start and end date) (NIT, Type of disability)'},
 { value: '19', label: 'Copy of the civil birth certificate required'},
 { value: '20', label: 'Validation'}, // motivo de rechzado por sospecha a incapacidad falsa
];

export const RejectedEpsOptions = [
  { value: '1',label: 'Minimum weeks of contribution'}, //semanas minimas de cotizacion,
  { value: '2',label: 'Incomplete documentation'}, // documentacion incompleta ,
  { value: '3',label: 'Arrears in contributions'},// mora en aportes ,
  { value: '4',label: 'Out of date of filing'},// fuera de fecha de radicacion ,
  { value: '5',label: 'No employer activated'},// sin empleador activado ,
  { value: '6',label: 'Compliance of 180'},// cumplimiento de 180 ,
  { value: '7',label: 'Pension fund corresponds'}, //corresponde fondo de pensiones
  { value: '8', label: 'Assumed Redes'},
 ];

export const TypesOfDisabilities = [
  { value: 'general_disease', label: 'Enfermedad General' },
  { value: 'traffic_accident', label: 'Accidente De Transito' },
  { value: 'maternal_leave', label: 'Licencia Materna' },
  { value: 'parental_leave', label: 'Licencia Paterna' },
  { value: 'work_accident', label: 'Accidente Laboral' },
];

export const TypesOfContingencies = [
  { value: 1, label: 'Initial' },
  { value: 2, label: 'Extension' }
];

export const IsTranscribedOptions = [
  { value: '1', label: 'yes' },
  { value: '0', label: 'no' }
];

export const ListEps = [
  { value: 'ESS024', label: 'COOSALUD EPS-S' },
  { value: 'EPS037', label: 'NUEVA EPS' },
  { value: 'ESS207', label: 'MUTUAL SER' },
  { value: 'EPS001', label: 'ALIANSALUD EPS' },
  { value: 'EPS002', label: 'SALUD TOTAL EPS S.A' },
  { value: 'EPS005', label: 'EPS SANITAS' },
  { value: 'EPS010', label: 'EPS SURA' },
  { value: 'EPS017', label: 'FAMISANAR' },
  { value: 'EPS018', label: 'SERVICIO OCCIDENTAL DE SALUD EPS SOS' },
  { value: 'EPS046', label: 'SALUD MÍA' },
  { value: 'EPS012', label: 'COMFENALCO VALLE' },
  { value: 'EPS008', label: 'COMPENSAR EPS' },
  { value: 'EAS016', label: 'EPM - EMPRESAS PUBLICAS DE MEDELLÍN' },
  { value: 'EAS027', label: 'FONDO DE PASIVO SOCIAL DE FERROCARRILES NACIONALES DE COLOMBIA' },
  { value: 'CCF055', label: 'CAJACOPI ATLÁNTICO' },
  { value: 'EPS025', label: 'CAPRESOCA' },
  { value: 'CCF102', label: 'COMFACHOCO' },
  { value: 'CCF050', label: 'COMFAORIENTE' },
  { value: 'CCF033', label: 'EPS FAMILIAR DE COLOMBIA' },
  { value: 'ESS062', label: 'ASMET SALUD' },
  { value: 'ESS118', label: 'EMSSANAR E.S.S.' },
  { value: 'EPSS34', label: 'CAPITAL SALUD EPS-S' },
  { value: 'EPSS40', label: 'SAVIA SALUD EPS' },
  { value: 'EPSI01', label: 'DUSAKAWI EPSI' },
  { value: 'EPSI03', label: 'ASOCIACION INDIGENA DEL CAUCA EPSI' },
  { value: 'EPSI04', label: 'ANAS WAYUU EPSI' },
  { value: 'EPSI05', label: 'MALLAMAS EPSI' },
  { value: 'EPSI06', label: 'PIJAOS SALUD EPSI' },
  { value: 'EPS047', label: 'SALUD BÓLIVAR EPS SAS' }
];

export const ListInsurances = [
  { value: 'ESS024', label: 'COOSALUD EPS-S', type_insurance_id: '1' },
  { value: 'EPS037', label: 'NUEVA EPS', type_insurance_id: '1' },
  { value: 'ESS207', label: 'MUTUAL SER', type_insurance_id: '1' },
  { value: 'EPS001', label: 'ALIANSALUD EPS', type_insurance_id: '1' },
  { value: 'EPS002', label: 'SALUD TOTAL EPS S.A', type_insurance_id: '1' },
  { value: 'EPS005', label: 'EPS SANITAS', type_insurance_id: '1' },
  { value: 'EPS010', label: 'EPS SURA', type_insurance_id: '1' },
  { value: 'EPS017', label: 'FAMISANAR', type_insurance_id: '1' },
  { value: 'EPS018', label: 'SERVICIO OCCIDENTAL DE SALUD EPS SOS', type_insurance_id: '1' },
  { value: 'EPS046', label: 'SALUD MÍA', type_insurance_id: '1' },
  { value: 'EPS012', label: 'COMFENALCO VALLE', type_insurance_id: '1' },
  { value: 'EPS008', label: 'COMPENSAR EPS', type_insurance_id: '1' },
  { value: 'EAS016', label: 'EPM - EMPRESAS PUBLICAS DE MEDELLÍN', type_insurance_id: '1' },
  { value: 'EAS027', label: 'FONDO DE PASIVO SOCIAL DE FERROCARRILES NACIONALES DE COLOMBIA', type_insurance_id: '1' },
  { value: 'CCF055', label: 'CAJACOPI ATLÁNTICO', type_insurance_id: '1' },
  { value: 'EPS025', label: 'CAPRESOCA', type_insurance_id: '1' },
  { value: 'CCF102', label: 'COMFACHOCO', type_insurance_id: '1' },
  { value: 'CCF050', label: 'COMFAORIENTE', type_insurance_id: '1' },
  { value: 'CCF033', label: 'EPS FAMILIAR DE COLOMBIA', type_insurance_id: '1' },
  { value: 'ESS062', label: 'ASMET SALUD', type_insurance_id: '1' },
  { value: 'ESS118', label: 'EMSSANAR E.S.S.', type_insurance_id: '1' },
  { value: 'EPSS34', label: 'CAPITAL SALUD EPS-S', type_insurance_id: '1' },
  { value: 'EPSS40', label: 'SAVIA SALUD EPS', type_insurance_id: '1' },
  { value: 'EPSI01', label: 'DUSAKAWI EPSI', type_insurance_id: '1' },
  { value: 'EPSI03', label: 'ASOCIACION INDIGENA DEL CAUCA EPSI', type_insurance_id: '1' },
  { value: 'EPSI04', label: 'ANAS WAYUU EPSI', type_insurance_id: '1' },
  { value: 'EPSI05', label: 'MALLAMAS EPSI', type_insurance_id: '1' },
  { value: 'EPSI06', label: 'PIJAOS SALUD EPSI', type_insurance_id: '1' },
  { value: 'EPS047', label: 'SALUD BÓLIVAR EPS SAS', type_insurance_id: '1' },
  { value: 'ARL01', label: 'ARL SURA', type_insurance_id: '2' }
];



export const documentsTypeDisabilities = [
  {
    key: "general_disease",
    id: 1,
    typedocuments: [
      {
        name: "Original Inability",
        id: 1,
        formNameArray: "original_inability",
      },
      {
        name: "Summary Of Care / Epicrisis",
        id: 2,
        formNameArray: "epicrisis",
      },
    ],
  },
  {
    key: "traffic_accident",
    id: 2,
    typedocuments: [
      {
        name: "Original Inability",
        id: 1,
        formNameArray: "original_inability",
      },
      { name: "Furips", id: 3, formNameArray: "furips" },
      { name: "Soat", id: 4, formNameArray: "soat" },
      {
        name: "Summary Of Care / Epicrisis",
        id: 2,
        formNameArray: "epicrisis",
      },
      {
        name: "Format F103",
        id: 8,
        formNameArray: "format_f103",
        onlyForEps: ["EPS002"],
      },
    ],
  },
  {
    key: "maternal_leave",
    id: 3,
    typedocuments: [
      {
        name: "Original Inability",
        id: 1,
        formNameArray: "original_inability",
      },
      {
        name: "Civil Birth Registry",
        id: 5,
        formNameArray: "civil_birth_registry",
      },
      {
        name: "Summary Of Care / Epicrisis With Weeks Of Gestation",
        id: 6,
        formNameArray: "epicrisis_with_weeks_of_gestation",
      },
    ],
  },
  {
    key: "parental_leave",
    id: 4,
    typedocuments: [
      {
        name: "Civil Birth Registry",
        id: 5,
        formNameArray: "civil_birth_registry",
      },
      {
        name: "Summary Of Care / Epicrisis With Weeks Of Gestation",
        id: 6,
        formNameArray: "epicrisis_with_weeks_of_gestation",
      },
    ],
  },
  {
    key: "work_accident",
    id: 5,
    typedocuments: [
      {
        name: "Original Inability",
        id: 1,
        formNameArray: "original_inability",
      },
    ],
  },
];

export const DocumentTypes = [
  { value: 'CC', label: 'Cédula De Ciudadanía' },
  { value: 'TI', label: 'Tarjeta De Identidad' },
  { value: 'RC', label: 'Registro Civil' },
  { value: 'PPT', label: 'Permiso Por Protección Temporal' },
  { value: 'TE', label: 'Tarjeta De Extranjería' },
  { value: 'CE', label: 'Cédula De Extranjería' },
  { value: 'NIT', label: 'NIT' },
  { value: 'PAS', label: 'Pasaporte' }
];



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/disability/components/candidate-disabilities/data.constants.ts